<template>
  <Header />
  <div class="py-2 bg-gradient-to-b from-red-50 to-transparent w-full h-full lg:pb-2 relative">
<UpcomingList />

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import UpcomingList from "@/components/UpcomingList.vue";

export default {
  name: "UpcomingView",
  components: {
    Header,
    UpcomingList,
    Footer,
  },
  created() { },
  computed: {},
};
</script>
